import { IRoute } from "@interfaces";
import { LayoutError } from "@layouts";
import {
    PageAddCard,
    PageAuth,
    PageAuthHub,
    PageBadges,
    PageBadgesDetail,
    PageBenefit,
    PageBmiForm,
    PageBmiResult,
    PageCallbackFB,
    PageCard,
    PageCardDetail,
    PageCardMember,
    PageChannelCollect,
    PageClientLink,
    PageCommunityEvent,
    PageCommunityEventDetail,
    PageCoupon,
    PageCrypto,
    PageDailyCheckIn,
    PageError404,
    PageEventActivity,
    PageEventDetails,
    PageEventProgress,
    PageFitnessCampaign,
    PageFreePoint,
    PageGetPointFromQr,
    PageHistoryRedeem,
    PageHome,
    PageInviteBySeller,
    PageInviteFriend,
    PageLiffScanQrcode,
    PageLineLogin,
    PageLineTelOTP,
    PageLinkBuying,
    PageListOfWinner,
    PageLuckyDraw,
    PageMemberCard,
    PageMemberGroup,
    PageMemberType,
    PageMemberTypeDetail,
    PageMemberTypeUpload,
    PageMission,
    PageMyParking,
    PageMyQR,
    PageMyStateLeaderBoardPage,
    PageMyStatePage,
    PageMyTools,
    PageNewHome,
    PageParking,
    PagePersonalFitness,
    PagePrivacy,
    PagePrivilege,
    PageProfile,
    PagePurchases,
    PageRedirectToNoCode,
    PageRedirectToSubscriptionNoCode,
    PageRegisterOrder,
    PageRegisterWarranty,
    PageResetPassword,
    PageResetPasswordEmail,
    PageReward,
    PageSelectChannel,
    PageSignIn,
    PageSignUp,
    PageSignUpFrom,
    PageSignUpOTP,
    PageSimpleWheel,
    PageSocialMediaPage,
    PageSpinWheel,
    PageSurvey,
    PageSurveyDetail,
    PageSwitchHistoryPublic,
    PageTermAndCondition,
    PageTestPage,
    PageTestPage2,
    PageTierDetail,
    PageTopSpender,
    PageTopSpenderList,
    PageTopSpenderOrderList,
    PageTrafficSource,
    PageUploadActivity,
    PageUploadReceipt,
    PageUploadReceiptPunkin,
    PageUserSetting,
    PageVerify,
    PageVirtualMedical,
    PageWarrantyList,
    PageWelcome,
} from "@pages";
import { PageBmiHistory } from "src/Pages/BmiHistory";
import { PageLogin } from "src/Pages/Login";
import { PagePurpose } from "src/Pages/Purpose";
import { PageRedirectToExternalFromLiff } from "src/Pages/RedirectToExternalFromLiff";
import { PageRedirectToLine } from "src/Pages/RedirectToLine";
// import { PageTopSpender, PageTopSpenderList } from "src/Pages/TopSpender";
// import { PageTopSpenderOrderList } from "src/Pages/TopSpender/OrderList";

export const PATH_TESTPAGE = "/testpage";
export const PATH_TESTPAGE2 = "/testpage-2";

export const PATH_TERM_AND_CONDITION = "/term-and-condition";

export const PATH_HOME = "/";
export const PATH_MY_QR = "/my-qr";
export const PATH_LOGIN = "/login";
export const PATH_404 = "/404";
export const PATH_PROFILE = "/profile";
export const PATH_UPLOAD_RECEIPT = "/upload-receipt";
export const PATH_UPLOAD_ACTIVITY = "/upload-activity";
export const PATH_MEMBER_TYPE = "/member-type";
export const PATH_MEMBER_TYPE_UPLOAD = "/member-type-upload";
export const PATH_CARD = "/card";
export const PATH_CARD_MEMBER = "/card-member";

//sign-up
export const PATH_SIGN_UP = "/sign-up";
export const PATH_OTP = "/otp";
export const PATH_LINE_TELE_OTP = "/line-tele/otp";
// export const PATH_SIGN_UP_FORM = "/sign-up/form";
export const PATH_SIGN_UP_FORM = "/";
//sign-in
// export const PATH_SIGN_IN = "/sign-in";
export const PATH_SIGN_IN = "/";
//auth
export const PATH_AUTH = "/auth";
//reset password
export const PATH_RESET_PASSWORD_EMAIL = "/reset-password/email";
export const PATH_RESET_PASSWORD = "/reset-password";
//line
export const PATH_LINE_LOGIN = "/line-login";
//traffic source
export const PATH_TRAFFIC_SOURCE = "/traffic_source";
//invite friend
export const PATH_INVITE = "/invite";
export const PATH_INV_SELLER = "/invite-seller";
//add card
export const PATH_ADD_CARD = "/add-card";
//coupon
export const PATH_COUPON = "/coupon";

//reward
export const REWARD = "/reward";
//benefit
export const PATH_BENEFIT = "/benefit";
//benefit
export const PATH_FREE_POINT = "/free-point";
//welcome
// export const PATH_WELCOME = "/welcome";
export const PATH_WELCOME = "/";
//user
export const PATH_USER_SETTING = "/user/setting";
export const PATH_USER_VERIFY = "/user/verify";
//tier
export const PATH_TIER_DETAIL = "/tier/detail";
//survey
export const PATH_SURVEY = "/survey";
export const PATH_SURVEY_DETAIL = "/survey/detail";
//dailycheckin
export const PATH_DAILYCHECKIN = "/daily-checkin";
//purchases
export const PATH_PURCHASES = "/purchases";
//mission
export const PATH_MISSION = "/mission";
// luckydraw
export const PATH_LUCKYDRAW = "/lucky-draw";
// history redeem
export const PATH_HISTORYREDEEM = "/history-redeem";
// membercard
export const PATH_MEMBERCARD = "/profile/membercard";
// privilege
export const PATH_PRIVILEGE = "/privilege";
// Spin Wheel
export const PATH_SPINWHEEL = "/spin-wheel";
// BMI RESULT
export const PATH_BMIRESULT = "/bmi-result";
// BMI FORM
export const PATH_BMIFORM = "/bmi-form";
// BMI History
export const PATH_BMIHISTORY = "/bmi-history";
// Parking
export const PATH_PARKING = "/parking";
// My Parking
export const PATH_MYPARKING = "/myparking";
// List of Winner
export const PATH_LIST_OF_WINNER = "/spin-wheel/list-of-winner";

//client-link
export const PATH_CLIENT_LINK = "/client-link";

export const PATH_HISTORY_PUBLIC = "/history";

export const PATH_CALLBACK_FB = "/fb/callback";

export const PATH_PRIVACY_MANAGEMENT = "/privacy/management";

export const PATH_NEW_HOME = "/new";

export const PATH_SOCIAL_MEDIA_PAGE = "/social-media";

export const PATH_MY_STATE = "/my-state";

export const PATH_MY_STATE_LEADERBOARD = "/my-state-leaderboard";

export const PATH_BADGES = "/badges";
export const PATH_BADGES_DETAIL = "/badges-detail";
export const PATH_COMMUNITY_EVENT = "/community-event";
export const PATH_COMMUNITY_EVENT_DETAIL = "/community-event-detail";

export const PATH_PERSONAL_FITNESS = "/personal-campaign";

//top spender
export const PATH_TOP_SPENDER = "/leaderboards";

//event activity
export const PATH_EVENT_ACTIVITY = "/event-activity";
//virtual medical
export const PATH_VIRTUAL_MEDICAL = "/virtual-medical";

export const PATH_REDIRECT_TO_LINE = "/redirect-to-line";
//liff scan qrcode
export const LIFF_SCAN_QRCODE = "/qrcode-scanner";

export const PATH_FITNESS_CAMPAIGN = "/campaign";
export const PATH_GET_POINT_FROM_QR = "/qrclaimpoints";
export const PATH_CHANNEL_COLLECT = "/channel-collect";
export const PATH_LINK_BUYING = "/link-buying";
export const PATH_SELECT_CHANNEL = "/select-channel";
export const PATH_REGISTER_ORDER = "/register-order";
export const PATH_WARRANTY_LIST = "/warranty/list";
export const PATH_REGISTER_WARRANTY = "/warranty";
export const PATH_MY_DEVICE = "/my-device";
export const PATH_MY_TOOLS = "/my-tools";

export const PATH_REDIRECT_TO_NOCODE = "/autoredirect";
export const PATH_REDIRECT_TO_EXTERNAL_FROM_LIFF = "/externalredirect";
export const PATH_REDIRECT_TO_SUBSCRIPTION_NOCODE = "/subscriptionredirect";

export const PATH_CRYPTO = "/crypto";

export const routes: Array<IRoute> = [
    { path: PATH_CRYPTO, component: PageCrypto, exact: true },
    { path: PATH_LOGIN, component: PageLogin, exact: true },
    { path: PATH_TESTPAGE, component: PageTestPage, exact: true },
    { path: PATH_TESTPAGE2, component: PageTestPage2, exact: true },

    { path: PATH_TERM_AND_CONDITION, component: PageTermAndCondition, exact: true },
    //home
    { path: PATH_HOME, component: PageHome, exact: true },
    { path: PATH_MY_QR, component: PageMyQR, exact: true },
    { path: PATH_PROFILE, component: PageProfile, exact: true },
    { path: PATH_UPLOAD_RECEIPT, component: PageUploadReceipt, exact: true },
    { path: PATH_UPLOAD_RECEIPT + "/:id", component: PageUploadReceiptPunkin, exact: true },
    { path: PATH_UPLOAD_ACTIVITY + "/:id", component: PageUploadActivity, exact: true },
    { path: PATH_MEMBER_TYPE, component: PageMemberGroup, exact: true },
    { path: PATH_MEMBER_TYPE + "/:gLink", component: PageMemberType, exact: true },
    {
        path: PATH_MEMBER_TYPE + "/:gLink" + "/:tLink",
        component: PageMemberTypeDetail,
        exact: true,
    },

    { path: PATH_MEMBER_TYPE_UPLOAD, component: PageMemberTypeUpload, exact: true },
    { path: PATH_CARD, component: PageCard, exact: true },
    { path: PATH_CARD + "/:id", component: PageCardDetail, exact: true },
    { path: PATH_CARD_MEMBER, component: PageCardMember, exact: true },
    { path: PATH_NEW_HOME, component: PageNewHome, exact: true },

    //sign-up
    { path: PATH_SIGN_UP, component: PageSignUp, exact: true },
    { path: PATH_OTP, component: PageSignUpOTP, exact: true },
    { path: PATH_LINE_TELE_OTP, component: PageLineTelOTP, exact: true },
    { path: PATH_SIGN_UP_FORM, component: PageSignUpFrom, exact: true },
    //sign in
    { path: PATH_SIGN_IN, component: PageSignIn, exact: true },
    { path: PATH_LINE_LOGIN, component: PageLineLogin, exact: true },
    //auth
    { path: PATH_AUTH + "/:id", component: PageAuth, exact: true },
    //reset password
    { path: PATH_RESET_PASSWORD_EMAIL, component: PageResetPasswordEmail, exact: true },
    { path: PATH_RESET_PASSWORD + "/:resetPasswordId", component: PageResetPassword, exact: true },
    //traffic source
    { path: PATH_TRAFFIC_SOURCE + "/:id", component: PageTrafficSource, exact: true },
    //invite friend
    { path: PATH_INVITE + "/:id", component: PageInviteFriend, exact: true },
    { path: PATH_INV_SELLER + "/:id", component: PageInviteBySeller, exact: true },
    // add card
    { path: PATH_ADD_CARD, component: PageAddCard, exact: true },
    //coupon source
    { path: PATH_COUPON + "/:id", component: PageCoupon, exact: true },
    { path: PATH_COUPON + "/:id/:idParent/:alienCode", component: PageCoupon, exact: true },
    { path: PATH_COUPON + "/:id/:idParent", component: PageCoupon, exact: true },
    //Reward source
    { path: REWARD + "/:id", component: PageReward, exact: true },
    //Benefit source
    { path: PATH_BENEFIT + "/:id", component: PageBenefit, exact: true },
    //Benefit source
    { path: PATH_FREE_POINT + "/:id", component: PageFreePoint, exact: true },
    //welcome
    { path: PATH_WELCOME, component: PageWelcome, exact: true },
    //user
    { path: PATH_USER_SETTING, component: PageUserSetting, exact: true },
    { path: PATH_USER_VERIFY + "/:type", component: PageVerify, exact: true },
    //tier
    { path: PATH_TIER_DETAIL, component: PageTierDetail, exact: true },
    //survey
    { path: PATH_SURVEY, component: PageSurvey, exact: true },
    { path: PATH_SURVEY + "/:id", component: PageSurveyDetail, exact: true },
    { path: PATH_SURVEY + "/:id" + "/:surveyType", component: PageSurveyDetail, exact: true },
    { path: PATH_SURVEY_DETAIL, component: PageSurveyDetail, exact: true },
    // dailycheckin
    { path: PATH_DAILYCHECKIN, component: PageDailyCheckIn, exact: true },
    // Purchases
    { path: PATH_PURCHASES, component: PagePurchases, exact: true },
    // mission
    { path: PATH_MISSION, component: PageMission, exact: true },
    // LuckyDraw
    { path: PATH_LUCKYDRAW, component: PageLuckyDraw, exact: true },
    // Social Media
    { path: PATH_SOCIAL_MEDIA_PAGE, component: PageSocialMediaPage, exact: true },

    { path: PATH_MY_STATE + "/:id", component: PageMyStatePage, exact: true },

    {
        path: PATH_MY_STATE_LEADERBOARD + "/:id",
        component: PageMyStateLeaderBoardPage,
        exact: true,
    },

    { path: PATH_BADGES, component: PageBadges, exact: true },
    { path: PATH_BADGES_DETAIL, component: PageBadgesDetail, exact: true },

    { path: PATH_COMMUNITY_EVENT, component: PageCommunityEvent, exact: true },
    { path: PATH_COMMUNITY_EVENT_DETAIL, component: PageCommunityEventDetail, exact: true },

    { path: PATH_PERSONAL_FITNESS + "/:id", component: PagePersonalFitness, exact: true },
    // List of Winner
    { path: PATH_LIST_OF_WINNER, component: PageListOfWinner, exact: true },
    // History Redeem
    { path: PATH_HISTORYREDEEM, component: PageHistoryRedeem, exact: true },
    // memberCard
    { path: PATH_MEMBERCARD, component: PageMemberCard, exact: true },
    // privilege
    { path: PATH_PRIVILEGE, component: PagePrivilege, exact: true },
    { path: PATH_PRIVILEGE + "/:id", component: PagePrivilege, exact: true },
    // SpinWheel
    { path: PATH_SPINWHEEL, component: PageSpinWheel, exact: true },
    // BMI Result
    { path: PATH_BMIRESULT, component: PageBmiResult, exact: true },
    // BMI Form
    { path: PATH_BMIFORM, component: PageBmiForm, exact: true },
    { path: PATH_BMIHISTORY, component: PageBmiHistory, exact: true },
    // Parking
    { path: PATH_PARKING, component: PageParking, exact: true },
    // My Parking
    { path: PATH_MYPARKING, component: PageMyParking, exact: true },

    //client-link
    { path: PATH_CLIENT_LINK + "/:id", component: PageClientLink, exact: true },
    { path: PATH_PRIVACY_MANAGEMENT, component: PagePrivacy, exact: true },
    { path: PATH_PRIVACY_MANAGEMENT + "/:id", component: PagePurpose, exact: true },
    //histories
    { path: PATH_HISTORY_PUBLIC, component: PageSwitchHistoryPublic, exact: true },
    // fb callback
    { path: PATH_CALLBACK_FB, component: PageCallbackFB, exact: true },
    //top spender
    { path: PATH_TOP_SPENDER + "/home/:id", component: PageTopSpender, exact: true },
    { path: PATH_TOP_SPENDER + "/list" + "/:id", component: PageTopSpenderList, exact: true },
    {
        path: PATH_TOP_SPENDER + "/detail" + "/:id",
        component: PageTopSpenderOrderList,
        exact: true,
    },
    { path: PATH_EVENT_ACTIVITY + "/home", component: PageEventActivity, exact: true },
    { path: PATH_EVENT_ACTIVITY + "/details/:id", component: PageEventDetails, exact: true },
    { path: PATH_EVENT_ACTIVITY + "/progress", component: PageEventProgress, exact: true },
    { path: PATH_VIRTUAL_MEDICAL, component: PageVirtualMedical, exact: true },
    { path: PATH_GET_POINT_FROM_QR + "/:id", component: PageGetPointFromQr, exact: true },
    { path: LIFF_SCAN_QRCODE + "/:id", component: PageLiffScanQrcode, exact: true },
    { path: PATH_FITNESS_CAMPAIGN + "/:id", component: PageFitnessCampaign, exact: true },
    { path: PATH_CHANNEL_COLLECT, component: PageChannelCollect, exact: true },
    { path: PATH_LINK_BUYING, component: PageLinkBuying, exact: true },
    { path: PATH_SELECT_CHANNEL, component: PageSelectChannel, exact: true },
    { path: PATH_REGISTER_ORDER, component: PageRegisterOrder, exact: true },
    { path: PATH_REGISTER_WARRANTY, component: PageRegisterWarranty, exact: true },
    { path: PATH_WARRANTY_LIST, component: PageWarrantyList, exact: true },
    { path: PATH_MY_DEVICE, component: PageMyTools, exact: true },
    { path: "/auth-hub", component: PageAuthHub, exact: true },
    // { path: PATH_MY_TOOLS, component: PageMyTools, exact: true },
    { path: "/simple-wheel", component: PageSimpleWheel, exact: true },
    { path: PATH_REDIRECT_TO_LINE, component: PageRedirectToLine, exact: true },
    { path: PATH_REDIRECT_TO_NOCODE, component: PageRedirectToNoCode, exact: true },
    {
        path: PATH_REDIRECT_TO_EXTERNAL_FROM_LIFF,
        component: PageRedirectToExternalFromLiff,
        exact: true,
    },
    {
        path: PATH_REDIRECT_TO_SUBSCRIPTION_NOCODE,
        component: PageRedirectToSubscriptionNoCode,
        exact: true,
    },
    { component: PageError404, exact: false, layout: LayoutError },
];
export const normalRoutes = [
    PATH_HOME,
    PATH_SIGN_UP_FORM,
    REWARD,
    PATH_TIER_DETAIL,
    PATH_USER_SETTING,
    PATH_BENEFIT,
    PATH_USER_VERIFY,
    PATH_PRIVILEGE,
    PATH_PRIVILEGE + "/:id",
];

export const authRoutes = [
    PATH_SIGN_UP,
    PATH_OTP,
    PATH_SIGN_IN,
    PATH_RESET_PASSWORD_EMAIL,
    PATH_RESET_PASSWORD,
    PATH_WELCOME,
];

export const publicRoutes = [
    PATH_HISTORY_PUBLIC,
    PATH_COUPON,
    PATH_FREE_POINT,
    PATH_CLIENT_LINK,
    PATH_TRAFFIC_SOURCE,
    PATH_INVITE,
    PATH_INV_SELLER,
    PATH_REDIRECT_TO_NOCODE,
    PATH_REDIRECT_TO_EXTERNAL_FROM_LIFF,
    PATH_AUTH,
    PATH_REDIRECT_TO_LINE,
    PATH_404,
];
